export default {
  login: {
    test: 'This is a test',
  },
};
